var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFCC1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9385 8.0005C15.7732 8.0005 12.3999 11.3738 12.3999 15.5396C12.3999 17.1249 12.8875 18.6487 13.8221 19.9291L14.0253 20.2134L17.9473 25.7618C17.9473 25.7618 18.4353 26.5537 19.4715 26.5537H20.4266C21.4633 26.5537 21.9508 25.7618 21.9508 25.7618L25.8723 20.2134L26.0761 19.9291C27.0111 18.6286 27.4987 17.1249 27.4987 15.5401C27.4781 11.3733 24.1048 8.0005 19.9385 8.0005ZM23.0476 17.7747L22.8444 18.059L19.9586 22.1437L17.0532 18.059L16.8495 17.7542C16.382 17.0839 16.1182 16.3315 16.1182 15.5191C16.1176 15.0173 16.2161 14.5202 16.4078 14.0565C16.5996 13.5927 16.881 13.1713 17.2359 12.8164C17.5907 12.4616 18.0121 12.1802 18.4759 11.9884C18.9397 11.7966 19.4367 11.6982 19.9385 11.6987C20.4404 11.6982 20.9375 11.7966 21.4012 11.9884C21.865 12.1802 22.2864 12.4616 22.6412 12.8164C22.9961 13.1713 23.2775 13.5927 23.4693 14.0565C23.6611 14.5202 23.7595 15.0172 23.759 15.5191C23.7605 16.3264 23.512 17.1143 23.0476 17.7747ZM17.8252 29.9476C17.8252 28.8098 18.7196 27.8747 19.9185 27.8747C21.1379 27.8747 22.0119 28.7892 22.0119 29.9271V29.9476C22.0119 31.0654 21.1174 32 19.8985 32C18.6991 31.98 17.8252 31.0649 17.8252 29.9476Z",
    fill: "#00A082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer7);
export default __webpack_public_path__ + "static/media/offer_7.a063fd5c4c4d3559de198acc5a4de413.svg";
export { ForwardRef as ReactComponent };